<template>
	<div class="fee-card">
		<van-cell center :title="title" :border="false" v-if="showTitle">
		  	<template #icon>
				<div class="left-icon">|</div>
			</template>
  		</van-cell>
		<van-grid :border="false" :column-num="columnNums">
			<van-grid-item v-for="(item,index) in listArr" :key="index" @click="handleItemClick(item)">
				<template #icon>
					<div class="fee-item-image-wrapper">
						<div v-if="$utils.isNotEmpty(item.src)" class="fee-item-icon-size">
							<img :src="item.src">
						</div>
						<div v-else :class="feeItemImageClass(item)" class="fee-item-icon-size"></div>
					</div>
				</template>
				<template #text>
					<span class="van-grid-item__text van-multi-ellipsis--l2">{{ item.name }}</span>
				</template>
			</van-grid-item>
		</van-grid>
	</div>
</template>

<script>
	import utils from '@/utils/util'
	export default {
		name: "FeeCard",
        props: {
			listArr: Array,
			title: String,
			columnNums:{
				type:[String,Number],
				default:3,
			},
			showTitle:{
				type:Boolean,
				default:true,
			}
        },
		methods: {
			feeItemImageClass(item) {
                if (utils.isNotEmpty(item.icon)) {
                    return `fee-item-${item.icon}-img`
                } else {
                    return 'fee-item-default-img'
                }
			},
			
			handleItemClick(item) {
				console.log('点击的item-----',item)
                if (utils.isNotEmpty(item.router)) {
                    this.$router.push({path: item.router})
                } else {
                    item.onClick(item)
                }
			}
		}
	}
</script>

<style lang="scss" scoped>

</style>